function pickApiBase(devKey, stagingKey, stableKey) {
  const dev = import.meta.env[devKey];
  const staging = import.meta.env[stagingKey];
  const stable = import.meta.env[stableKey];
  const forceStaging =
    import.meta.env.VITE_USE_STAGING_API === "true" ||
    import.meta.env.VITE_USE_STAGING_API === true;
  if (import.meta.env.DEV && dev) return dev;
  if (!import.meta.env.DEV && forceStaging) return staging || dev || stable;
  return stable || dev;
}

export function salesPageApiBase() {
  return pickApiBase(
    "VITE_DEV_CF_API_URL",
    "VITE_STAGING_CF_API_URL",
    "VITE_STABLE_CF_API_URL"
  );
}

export const SALES_BUILDER_SOURCE = "atomicpay-sales-builder";
export const CHECKOUT_EMBED_SOURCE = "atomicpay-checkout-embed";
